import React, { useEffect, useState } from "react";
import { delete_newsletter_email, get_newsletter_lists } from "../../reduxData/user/userAction";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import EmptyData from "../../components/EmptyData";
import Input from "@mui/joy/Input";
import Button from "@mui/joy/Button";
import Modal from "@mui/joy/Modal";
import ModalDialog from "@mui/joy/ModalDialog";
import DialogTitle from "@mui/joy/DialogTitle";
import DialogContent from "@mui/joy/DialogContent";
import { Box } from "@mui/joy";
import CustomPagination from "../../components/CustomPagination";
import { formatDateTime } from "../../hooks/formatDateTime";
import { useTranslation } from "react-i18next";

let hasFetchedApis = false;

const NewsLetter = () => {
    const { t } = useTranslation();
    const { user, accessToken, userPermissions } = useSelector((state) => state.auth);
    const { newsletterLists, totalNewsletters } = useSelector((state) => state.user);
    const dispatch = useDispatch();
    const [deleteModal, setDeleteModal] = useState(false);
    const [data, setData] = useState(null);
    const [name, setName] = useState("");

    // fetch newsletter data 
    useEffect(() => {
        hasFetchedApis = true;
        const fetchData = async () => {
            await get_newsletter_lists(dispatch, 1, 10, name);
        };
        fetchData();
        return () => { hasFetchedApis = false; };
    }, []);

    // delete newsletter data 
    const deleteNewsletter = async () => {
        let isDeleted = await delete_newsletter_email(dispatch, data?.id);
        if (isDeleted) {
            await get_newsletter_lists(dispatch, 1, 10);
            setData(null);
            setDeleteModal(false);
        }
    };

    return (
        <div>
            <h3 className="mb-3 fw-600">
                {t("newsletter.title")} ({totalNewsletters})
            </h3>
            <div className="filters mb-3">
                <Input
                    id="nameInput"
                    type="text"
                    className="search-input"
                    placeholder={t("newsletter.searchPlaceholder")}
                    value={name}
                    onChange={async (e) => {
                        setName(e.target.value);
                        await get_newsletter_lists(dispatch, 1, 10, e.target.value);
                    }}
                />
            </div>
            <div className="table-responsive">
                <table className="table user-management-table table-hover">
                    <thead className="border-gray">
                        <th scope="col">{t("newsletter.serialNumber")}</th>
                        <th scope="col">{t("newsletter.email")}</th>
                        <th>{t("newsletter.createdAt")}</th>
                        {userPermissions?.newsletter?.delete && (<th scope="col" className="text-center">{t("newsletter.action")}</th>)}
                    </thead>
                    <tbody>
                        {totalNewsletters > 0 ?
                            newsletterLists.map((data, index) => (
                                <tr key={index}>
                                    <td>{index + 1}.</td>
                                    <td>{data?.email}</td>
                                    <td>{formatDateTime(data?.created_at)}</td>
                                    {userPermissions?.newsletter?.delete && (<td className="text-center">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="16"
                                            height="16"
                                            fill="currentColor"
                                            viewBox="0 0 16 16"
                                            className="cursor-pointer delete-icon bi bi-trash3-fill"
                                            onClick={() => { setData(data); setDeleteModal(true); }}
                                        >
                                            <path d="M11 1.5v1h3.5a.5.5 0 0 1 0 1h-.538l-.853 10.66A2 2 0 0 1 11.115 16h-6.23a2 2 0 0 1-1.994-1.84L2.038 3.5H1.5a.5.5 0 0 1 0-1H5v-1A1.5 1.5 0 0 1 6.5 0h3A1.5 1.5 0 0 1 11 1.5m-5 0v1h4v-1a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5M4.5 5.029l.5 8.5a.5.5 0 1 0 .998-.06l-.5-8.5a.5.5 0 1 0-.998.06m6.53-.528a.5.5 0 0 0-.528.47l-.5 8.5a.5.5 0 0 0 .998.058l.5-8.5a.5.5 0 0 0-.47-.528M8 4.5a.5.5 0 0 0-.5.5v8.5a.5.5 0 0 0 1 0V5a.5.5 0 0 0-.5-.5" />
                                        </svg>
                                    </td>)}
                                </tr>
                            )) : <EmptyData />}
                    </tbody>
                </table>
            </div>

            {totalNewsletters > 0 && (
                <CustomPagination
                    total={totalNewsletters}
                    onPageChange={(page, perPage) => { get_newsletter_lists(dispatch, page, perPage) }}
                />
            )}

            <Modal open={deleteModal} onClose={() => setDeleteModal(false)}>
                <ModalDialog>
                    <DialogTitle>{t("newsletter.deleteEmail")}</DialogTitle>
                    <DialogContent>
                        {t("newsletter.deleteConfirmation")}
                    </DialogContent>
                    <Box>
                        <Button onClick={() => { setData(null); setDeleteModal(false); }}>{t("newsletter.cancel")}</Button>
                        <Button
                            className="mx-2"
                            color="danger"
                            onClick={deleteNewsletter}
                        >
                            {t("newsletter.delete")}
                        </Button>
                    </Box>
                </ModalDialog>
            </Modal>
        </div>
    )
};

export default NewsLetter;